/** Coins du cadre géoréférencé de /docs/secteur4.pdf.
 * Page 1368×936, viewport PDF [36, 36, 1062, 900], dictionnaire /Measure /GEO.
 * L’image secteur4-map.jpg est ce cadre, pas une tuile NordQuest. */
export const SEPAQ_SHEET = {
  image: "/docs/secteur4-map.jpg",
  topLeft: [47.33909, -72.60152],
  topRight: [47.33383, -72.3622],
  bottomLeft: [47.20207, -72.6077],
  sourcePx: [4275, 3600],
  tiles: {
    url: "/maps/sepaq/{z}/{x}/{y}.jpg",
    minZoom: 11,
    maxNativeZoom: 15,
    bounds: [[47.19684, -72.6077], [47.33909, -72.3622]],
  },
};

export const MAP_CHOICES = [
  { id: "official", label: "Carte officielle Sépaq" },
  { id: "standard", label: "Carte simple" },
  { id: "satellite", label: "Satellite" },
  { id: "topo", label: "Relief" },
];
